let timer = null;
let scrollTriggerPromise = null;

function loadScrollTrigger() {
  if (!scrollTriggerPromise) {
    scrollTriggerPromise = import('gsap/ScrollTrigger').then(
      mod => mod.ScrollTrigger
    );
  }
  return scrollTriggerPromise;
}

/**
 * Debounced ScrollTrigger.refresh(true) — collapses rapid callers
 * into a single full recalculation. Safe to call from font load,
 * image decode, video metadata, resize observers, and DOM swaps.
 *
 * @param {number} [wait=200] - Debounce delay in ms
 */
export function safeRefresh(wait = 200) {
  clearTimeout(timer);
  timer = setTimeout(() => {
    loadScrollTrigger().then(ScrollTrigger => ScrollTrigger.refresh(true));
  }, wait);
}

/**
 * Immediate ScrollTrigger.refresh(true) — use after page transitions
 * or hydration where the next paint must have correct positions.
 * Cancels any pending debounced refresh to avoid double work.
 */
export function safeRefreshImmediate() {
  clearTimeout(timer);
  loadScrollTrigger().then(ScrollTrigger => ScrollTrigger.refresh(true));
}
